// TODO: add local and session storage keys to this file in future tickets
/**
 * a single plan name get from guest home page
 * @example "BASIC"
 */
export const STORAGE_KEY_SELECTED_PLAN_ON_GUEST = 'neon:selected-plan-on-guest'

/**
 * a list of plan sku get from the applicablePlans in query VOUCHER_WITHOUT_SKU_QUERY
 * @example "LBPREMTV,LBBASICTV"
 */
export const STORAGE_KEY_VOUCHER_APPLICABLE_PLANS = 'neon:voucher-applicable-plans'

/**
 * A prefilled voucher code to auto-populate the add-voucher form.
 * Set from external entry points (e.g. campaign callout) and consumed
 * as the default value when the AddVoucher module mounts.
 * Cleared from session storage once the user submits the form.
 * @example "SUMMER2026FREE"
 */
export const STORAGE_KEY_VOUCHER_PREFILLED = 'neon:voucher-prefilled'

/**
 * email get from the emailBox in guest home page
 * it will be used to initialize the login modal and sign up form
 */
export const STORAGE_KEY_EMAIL_ON_GUEST_HOME_PAGE = 'neon:email-on-guest-home-page'

/**
 * parental ratings array get from CONFIG_QUERY
 * @example "[{"rating":"G","label":"General (G)","ratingOrder":1}]"
 */
export const STORAGE_KEY_PARENTAL_RATINGS = 'neon:parental-ratings'

/**
 * Token used to authenticate the user, stored in localStorage.
 * It’s usually a JWT string received after login or during session rehydration
 */
export const STORAGE_KEY_TOKEN = 'token'

/**
 * Session keys for Segment to track active sessions in the browser
 * These keys are used for web session start and end events
 */
export const STORAGE_KEY_ACTIVE_SESSION_ID = 'activeSessionId'
export const STORAGE_KEY_ACTIVE_SESSION_TIMESTAMP = 'activeSessionTimestamp'
export const STORAGE_KEY_LAST_SESSION_ACTIVITY_TIME = 'lastSessionActivityTime'
